import { render, staticRenderFns } from "./ManageSpecialist.vue?vue&type=template&id=48016bc6"
import script from "./ManageSpecialist.vue?vue&type=script&lang=js"
export * from "./ManageSpecialist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports